import * as React from "react";

interface Props {
    label?: string | JSX.Element;
    textSize?: "sm";
    autoGrow?: boolean;
    accessory?: React.ReactNode;
}

export type TextAreaProps = Props & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
    (props, ref) => {
        const { label, className, textSize, autoGrow, accessory, ...rest } = props;

        const handleAutoGrow = (e: React.FormEvent<HTMLTextAreaElement>) => {
            e.currentTarget.parentElement.dataset.replicatedValue = e.currentTarget.value;
        };

        let textSizeClass = "";

        switch (textSize) {
            case "sm":
                textSizeClass = "text-sm";
                break;
        }

        const style: React.CSSProperties = {
            wordBreak: "break-word",
        };

        const accessoryPadding = accessory ? "pr-12" : "";
        const growWrapClass = accessory ? "grow-wrap grow-wrap--accessory" : "grow-wrap";

        const innerComponent = (
            <textarea
                ref={ref}
                style={style}
                className={`form-input rounded-sm md:rounded w-full disabled:bg-gray-100 border-gray-300 hover:border-brand-600 active:border-brand-400 focus:ring-2 focus:ring-brand-300 ${textSizeClass} ${accessoryPadding}`}
                onInput={autoGrow ? handleAutoGrow : undefined}
                {...rest}
            />
        );

        return (
            <div className={`${className ?? ""} relative w-full`}>
                <label>
                    {label ? <div className="mb-1">{label}</div> : null}
                    {autoGrow ? (
                        <div
                            style={style}
                            className={growWrapClass}
                            data-replicated-value={rest.value}>
                            {innerComponent}
                        </div>
                    ) : (
                        innerComponent
                    )}
                </label>
                {accessory ? (
                    <div className="absolute bottom-2 right-2">{accessory}</div>
                ) : null}
            </div>
        );
    },
);

TextArea.displayName = "TextArea";
